import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import useResizeWindow from "../../../utils/hook/useResizeWindows";
//import { RequestGetUILogo } from "../../../store/actions/dashboardActions";

//import LogoIcon from "../../Icon-SVG/LogoIcon";
import MenIcon from "../../Icon-SVG/MenIcon";
import DoughnutChartIcon from "../../Icon-SVG/DoughnutChartIcon";
import StatisticsIcon from "../../Icon-SVG/StatisticsIcon";
import DemoPopup from "../../common/DemoPopup/DemoPopup";
import InfoIcon from "../../Icon-SVG/InfoIcon";
import MarketIcon from "../../Icon-SVG/MarketIcon";
import SidebarItem from "./SidebarItem";
import IntegrationsIcon from "../../Icon-SVG/IntegrationsIcon";
import EmailIntegrationIcon from "../../Icon-SVG/EmailIntegrationIcon";
import FileIcon from "../../Icon-SVG/FileIcon";
import WebIcon from "../../Icon-SVG/WebIcon";
import EndpointIcon from "../../Icon-SVG/EndpointIcon";
import MessageIcon from "../../Icon-SVG/MessageIcon";
import OutlookIcon from "../../Icon-SVG/OutlookIcon";
import SharePointIcon from "../../Icon-SVG/SharePointIcon";
import FileSharesIcon from "../../Icon-SVG/FileSharesIcon";
import IcapIcon from "../../Icon-SVG/IcapIcon";
import EndpointMainIcon from "../../Icon-SVG/EndpointMainIcon";
import UsbIcon from "../../Icon-SVG/UsbIcon";
import AgentIcon from "../../Icon-SVG/AgentIcon";
import SettingIcon from "../../Icon-SVG/SettingIcon";
import NetworkDefenderIcon from "../../Icon-SVG/NetworkDefenderIcon";
import NetworkDetectionsIcon from "../../Icon-SVG/NetworkDetectionsIcon";
import UserIcon from "../../Icon-SVG/UserIcon";
import DataRetentionIcon from "../../Icon-SVG/DataRetentionIcon";
import DumpAndRestoreIcon from "../../Icon-SVG/DumpAndRestoreIcon";
import SyslogIcon from "../../Icon-SVG/SyslogIcon";
import SocialIcon from "../../Icon-SVG/SocialIcon";
import IocIcon from "../../Icon-SVG/IocIcon";
import UrlIcon from "../../Icon-SVG/UrlIcon";
import DomainIcon from "../../Icon-SVG/DomainIcon";
import DataFlowIcon from "../../Icon-SVG/DataFlowIcon";
import PublicApiIcon from "../../Icon-SVG/PublicApiIcon";
import MailGatewayIcon from "../../Icon-SVG/MailGatewayIcon";
import AnalyzedEmailIcon from "../../Icon-SVG/AnalyzedEmailIcon";
import BlockedEmailIcon from "../../Icon-SVG/BlockedEmailIcon";
import UnblockedEmailIcon from "../../Icon-SVG/UnblockedEmailIcon";
import InternetIcon from "../../Icon-SVG/InternetIcon";
import SendIcon from "../../Icon-SVG/SendIcon";
import LlmIcon from "../../Icon-SVG/LlmIcon";
import ProductIcon from "../../Icon-SVG/ProductIcon";
import ContainersIcon from "../../Icon-SVG/ContainersIcon";
import CustomSignaturesIcon from "../../Icon-SVG/CustomSignaturesIcon";
import YaraIcon from "../../Icon-SVG/YaraIcon";
import SnortIcon from "../../Icon-SVG/SnortIcon";
import ClamavIcon from "../../Icon-SVG/ClamavIcon";
import SearchIcon from "../../Icon-SVG/SearchIcon";
import { loadFromLocalStorage } from "../../../utils/localStorage";
import DataFlowText from "../../Icon-SVG/DataFlowText";
import CleanFileIcon from "../../Icon-SVG/CleanFileIcon";
import LogoIconMain from "../../Icon-SVG/LogoIconMain";
import InstallComputerIcon from "../../Icon-SVG/InstallComputerIcon";
import HashIcon from "../../Icon-SVG/HashIcon";
import PrtgIcon from "../../Icon-SVG/PrtgIcon";
import LdapIcon from "../../Icon-SVG/LdapIcon";
import UpdateSchedulerIcon from "../../Icon-SVG/UpdateSchedulerIcon";
import ServerIcon from "../../Icon-SVG/ServerIcon";
import HunterBoxIcon from "../../Icon-SVG/HunterBoxIcon";
import MA360Icon from "../../Icon-SVG/MA360Icon";
import SandboxIcon from "../../Icon-SVG/SandboxIcon";
// import CdrShieldIcon from "../../Icon-SVG/CdrShieldIcon";
// import ThreatHunterIcon from "../../Icon-SVG/ThreatHunterIcon";

import { RequestCheckExistingResponsibles } from "../../../store/actions/containerActions";

import "./styles.scss";
const dashboardItem = {
  to: "/newdash",
  icon: (pathname) => (
    <DoughnutChartIcon
      width={21}
      height={21}
      color={pathname === "/newdash" ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
    />
  ),
  text: "Dashboard",
};

const ma360Item = {
  to: "#",
  icon: (pathname) => <MA360Icon width={22} height={22} />,
  text: "MA 360°",
  subItems: [
    {
      to: "/dashboard",
      icon: (pathname, to) => (
        <SandboxIcon
          width={20}
          height={20}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "MA360° Core",
    },
    {
      to: "/phishbox",
      icon: (pathname, to) => (
        <InternetIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "PhishBox",
    },
    {
      to: "/hunterbox",
      icon: (pathname, to) => (
        <HunterBoxIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "HunterBox",
    },
    {
      to: "/historical-analysis",
      icon: (pathname, to) => (
        <MenIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Historical Results",
      shortText: "H. Results",
    },
  ],
};

const integrationsItem = {
  to: "#",
  icon: (pathname) => <IntegrationsIcon width={21} height={21} />,
  text: "Integrations & CDR",
  shortText: "Int. & CDR",
  subItems: [
    {
      to: "/cdr",
      icon: (pathname, to) => (
        <CleanFileIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "CDR",
    },
    {
      to: "#",
      icon: (pathname) => (
        <EmailIntegrationIcon width={18} height={18} color="var(--sidebar-item-secondary)" />
      ),
      text: "Email",
      subItems: [
        {
          to: "/imapemail",
          icon: (pathname, to) => (
            <MessageIcon
              width={18}
              height={18}
              color={pathname === to ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
            />
          ),
          text: "Imap Email",
          shortText: "Imap",
        },
        {
          to: "/postfixemail",
          icon: (pathname, to) => (
            <MessageIcon
              width={18}
              height={18}
              color={pathname === to ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
            />
          ),
          text: "Postfix Email",
          shortText: "Postfix",
        },
        {
          to: "/outlook",
          icon: (pathname, to) => (
            <OutlookIcon
              width={18}
              height={18}
              color={pathname === to ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
            />
          ),
          text: "Outlook Add-In",
          shortText: "Outlook",
        },
      ],
    },
    {
      to: "#",
      icon: (pathname) => <FileIcon width={18} height={18} color="var(--sidebar-item-secondary)" />,
      text: "File",
      subItems: [
        {
          to: "/sharepoint",
          icon: (pathname, to) => (
            <SharePointIcon
              width={18}
              height={18}
              color={pathname === to ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
            />
          ),
          text: "SharePoint",
          shortText: "Sh.Point",
        },
        {
          to: "/fileshare",
          icon: (pathname, to) => (
            <FileSharesIcon
              width={18}
              height={18}
              color={pathname === to ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
            />
          ),
          text: "File Share",
          shortText: "F. Share",
        },
      ],
    },
    {
      to: "#",
      icon: (pathname) => <WebIcon width={18} height={18} color="var(--sidebar-item-secondary)" />,
      text: "Web",
      subItems: [
        {
          to: "/proxy",
          icon: (pathname, to) => (
            <IcapIcon
              width={18}
              height={18}
              color={pathname === to ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
            />
          ),
          text: "ICAP Interface",
          shortText: "ICAP I.",
        },
        {
          to: "/tapper",
          icon: (pathname, to) => (
            <YaraIcon
              width={18}
              height={18}
              color={pathname === to ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
            />
          ),
          text: "TAP Interface",
          shortText: "TAP I.",
        },
      ],
    },
    {
      to: "#",
      icon: (pathname) => (
        <EndpointIcon width={18} height={18} color="var(--sidebar-item-secondary)" />
      ),
      text: "Endpoint",
      subItems: [
        {
          to: "/submissions",
          icon: (pathname, to) => (
            <EndpointMainIcon
              width={18}
              height={18}
              color={pathname === to ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
            />
          ),
          text: "Submissions",
          shortText: "Subs.",
        },
        {
          to: "/usbtransfer",
          icon: (pathname, to) => (
            <UsbIcon
              width={18}
              height={18}
              color={pathname === to ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
            />
          ),
          text: "USB Transfer",
          shortText: "Usb T.",
        },
      ],
    },
  ],
};

const agentsItem = {
  to: "#",
  icon: (pathname) => <AgentIcon width={21} height={21} />,
  text: "Threat Hunter",
  shortText: "T. Hunter",
  subItems: [
    {
      to: "/agentstatus",
      icon: (pathname, to) => (
        <InfoIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "All Agents",
      shortText: "A. Agents",
    },
    {
      to: "/agentinstallation",
      icon: (pathname, to) => (
        <InstallComputerIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Agent Installation",
      shortText: "A. Installation",
    },
    {
      to: "/threat-reports",
      icon: (pathname, to) => (
        <HunterBoxIcon
          width={15}
          height={15}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Threat Reports",
      shortText: "T. Reports",
    },
    {
      to: "/yara-results",
      icon: (pathname, to) => (
        <YaraIcon
          width={16}
          height={16}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Yara Results",
      shortText: "Y. Results",
    },
    {
      to: "/watermark-decoder",
      icon: (pathname, to) => (
        <FileIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "WMark Decoder",
      shortText: "WM. Decoder",
    },
  ],
};

const networkDefenderItem = {
  to: "#",
  icon: (pathname) => <NetworkDefenderIcon width={21} height={21} />,
  text: "Network Defender",
  shortText: "N. Defender",
  subItems: [
    {
      to: "/network-detections",
      icon: (pathname, to) => (
        <NetworkDetectionsIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Network Detections",
      shortText: "N. Detections",
    },
  ],
};

// const threatHunterItem = {
//   to: "#",
//   icon: (pathname) => <ThreatHunterIcon width={21} height={21} />,
//   text: "Threat Hunter",
//   shortText: "T. Hunter",
//   subItems: [
//     {
//       to: "/threat-hunter",
//       icon: (pathname, to) => (
//         <ThreatHunterIcon
//           width={18}
//           height={18}
//           color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
//         />
//       ),
//       text: "T. Hunter Detections",
//       shortText: "T.H. Detections",
//     },
//   ],
// };

const mailGatewayItem = {
  to: "#",
  icon: (pathname) => <MailGatewayIcon width={21} height={21} />,
  text: "Mail Gateway",
  shortText: "M. Gateway",
  subItems: [
    {
      to: "/mailgateway/dashboard",
      icon: (pathname, to) => (
        <DoughnutChartIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Dashboard",
    },
    {
      to: "/mailgateway/analyzed-emails",
      icon: (pathname, to) => (
        <AnalyzedEmailIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Analyzed Emails",
      shortText: "Analyzed E.",
    },
    {
      to: "/mailgateway/blocked-emails",
      icon: (pathname, to) => (
        <BlockedEmailIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Blocked Emails",
      shortText: "Blocked E.",
    },
    {
      to: "/mailgateway/unblocked-emails",
      icon: (pathname, to) => (
        <UnblockedEmailIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Unblocked Emails",
      shortText: "Unblocked E.",
    },
    {
      to: "/mailgateway/transfer-logs",
      icon: (pathname, to) => (
        <SendIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Transfer Logs",
      shortText: "Transfer L.",
    },
    {
      to: "/mailgateway/dynamic-phishing-emails",
      icon: (pathname, to) => (
        <InternetIcon
          width={19}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "PhishBox Links",
      shortText: "P.Links",
    },
  ],
};

const iocItem = {
  to: "#",
  icon: (pathname, to) => <IocIcon />,
  text: "IOCs",
  subItems: [
    {
      to: "/iocs/dashboard",
      icon: (pathname, to) => (
        <DoughnutChartIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Dashboard",
    },
    {
      to: "/iocs/urls",
      icon: (pathname, to) => (
        <UrlIcon
          width={20}
          height={20}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Urls",
    },
    {
      to: "/iocs/hosts-and-domains",
      icon: (pathname, to) => (
        <DomainIcon
          width={20}
          height={20}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Hosts and Domains",
      shortText: "Hs. & Ds.",
    },
    {
      to: "/iocs/hashes",
      icon: (pathname, to) => (
        <HashIcon
          width={20}
          height={20}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Hashes",
    },
  ],
};

const statisticsItem = {
  to: "/statistics",
  icon: (pathname, to) => (
    <StatisticsIcon color={pathname === "/statistics" && "var(--sidebar-active-icon)"} />
  ),
  text: "Statistics",
};

// const fsaItem = {
//   to: "#",
//   icon: (pathname) => <CdrShieldIcon width={21} height={21} />,
//   text: "FSA",
//   shortText: "FSA",
//   subItems: [
//     {
//       to: "/fsa/cdr",
//       icon: (pathname, to) => (
//         <CleanFileIcon
//           width={18}
//           height={18}
//           color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
//         />
//       ),
//       text: "CDR",
//     },
//     {
//       to: "/fsa/applications",
//       icon: (pathname, to) => (
//         <MarketIcon
//           width={18}
//           height={18}
//           color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
//         />
//       ),
//       text: "Applications",
//     },
//   ],
// };

const settingsItem = {
  to: "#",
  icon: (pathname) => <SettingIcon width={21} height={21} />,
  text: "Core Settings",
  subItems: [
    {
      to: "/settings/user-accounts",
      icon: (pathname, to) => (
        <UserIcon
          width={18}
          height={18}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "User Accounts",
    },
    {
      to: "/settings/data-retention",
      icon: (pathname, to) => (
        <DataRetentionIcon
          width={22}
          height={22}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Data Retention",
    },
    {
      to: "/settings/backup-and-restore",
      icon: (pathname, to) => (
        <DumpAndRestoreIcon
          width={22}
          height={22}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Backup & Restore",
      shortText: "Backup & R.",
    },
    {
      to: "/settings/notifications",
      icon: (pathname, to) => (
        <EmailIntegrationIcon
          width={21}
          height={21}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Notifications",
    },
    {
      to: "/settings/auto-submission",
      icon: (pathname, to) => (
        <EndpointMainIcon
          width={20}
          height={20}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Auto Submission",
      shortText: "Auto Sub.",
    },
    {
      to: "/settings/ldap",
      icon: (pathname, to) => (
        <LdapIcon
          width={22}
          height={22}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "LDAP",
    },
    {
      to: "/settings/publicapi",
      icon: (pathname, to) => (
        <PublicApiIcon
          width={21}
          height={21}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Public API",
    },
    {
      to: "/settings/core-servers",
      icon: (pathname, to) => (
        <ServerIcon
          width={21}
          height={21}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Core Servers",
    },
    {
      to: "#",
      icon: (pathname, to) => (
        <CustomSignaturesIcon width={21} height={19} color="var(--sidebar-item-secondary)" />
      ),
      text: "C. Signatures",
      subItems: [
        {
          to: "/settings/custom-signatures/yara",
          icon: (pathname, to) => (
            <YaraIcon
              width={18}
              height={18}
              color={pathname === to ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
            />
          ),
          text: "Yara",
        },
        {
          to: "/settings/custom-signatures/snort",
          icon: (pathname, to) => (
            <SnortIcon
              width={18}
              height={18}
              color={pathname === to ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
            />
          ),
          text: "Snort",
        },
        {
          to: "/settings/custom-signatures/clamav",
          icon: (pathname, to) => (
            <ClamavIcon
              width={18}
              height={18}
              color={pathname === to ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
            />
          ),
          text: "Clamav",
        },
        {
          to: "/settings/custom-signatures/ioc",
          icon: (pathname, to) => (
            <IocIcon
              width={18}
              height={18}
              color={pathname === to ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
            />
          ),
          text: "IOC",
        },
      ],
    },
    {
      to: "/settings/update-scheduler",
      icon: (pathname, to) => (
        <UpdateSchedulerIcon
          width={21}
          height={21}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Update Scheduler",
      shortText: "Update Sch.",
    },
    {
      to: "/settings/phishbox",
      icon: (pathname, to) => (
        <InternetIcon
          width={20}
          height={19}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Phishbox",
    },
    {
      to: "/settings/llm",
      icon: (pathname, to) => (
        <LlmIcon
          width={21}
          height={21}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "LLM",
    },
  ],
};

const publicItem = {
  to: "#",
  icon: (pathname) => <SettingIcon width={21} height={21} />,
  text: "Public API Key",
  subItems: [
    {
      to: "/settings/publicapi",
      icon: (pathname, to) => (
        <PublicApiIcon
          width={21}
          height={21}
          color={pathname === to ? "var(--sidebar-active-icon)" : "var(--sidebar-item-secondary)"}
        />
      ),
      text: "Public API",
    },
  ],
};

const infoItem = {
  to: "/system-info",
  icon: (pathname) => (
    <InfoIcon
      width={21}
      height={21}
      color={pathname === "/system-info" && "var(--sidebar-active-icon)"}
    />
  ),
  text: "Info",
};

const containerServicesItem = {
  to: "/containers",
  icon: (pathname) => (
    <ContainersIcon
      width={21}
      height={21}
      color={pathname === "/containers" ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
    />
  ),
  text: "C. Services",
};

const logsItem = {
  to: "/logs",
  icon: (pathname) => (
    <SyslogIcon
      width={21}
      height={21}
      color={pathname === "/logs" ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
    />
  ),
  text: "Logs",
};

const integrationMarketItem = {
  to: "/integration-market",
  icon: (pathname) => (
    <MarketIcon
      width={21}
      height={21}
      color={pathname === "/integration-market" && "var(--sidebar-active-icon)"}
    />
  ),
  text: "Integration Market",
  shortText: "Int. Market",
};

const productsItem = {
  to: "/products",
  icon: (pathname) => (
    <ProductIcon
      width={20}
      height={20}
      color={pathname === "/products" ? "var(--sidebar-active-icon)" : "var(--text-color-card)"}
    />
  ),
  text: "Product Settings",
};

const publicApiDocsItem = {
  to: "/api/docu3318-v1",
  external: true,
  icon: () => <PublicApiIcon width={21} height={21} color="var(--text-color-card)" />,
  text: "Public API",
};

// Every route reachable straight from the sidebar. The header uses this to
// decide whether a page was opened from the menu (no back shortcut needed)
// or from inside another page (back shortcut shown).
const collectRoutes = (menuItem) => [
  menuItem.to,
  ...(menuItem.subItems || []).flatMap(collectRoutes),
];

export const SIDEBAR_ROUTES = [
  dashboardItem,
  ma360Item,
  integrationsItem,
  iocItem,
  statisticsItem,
  agentsItem,
  networkDefenderItem,
  mailGatewayItem,
  settingsItem,
  publicItem,
  infoItem,
  containerServicesItem,
  logsItem,
  integrationMarketItem,
  productsItem,
]
  .flatMap(collectRoutes)
  .filter((route) => route && route !== "#");

// Sidebar menu search: an item matches by its text/shortText; a parent whose
// child matches is kept with only the matching children
const menuItemMatches = (menuItem, q) =>
  menuItem.text?.toLowerCase().includes(q) || menuItem.shortText?.toLowerCase().includes(q);

const filterMenuItem = (menuItem, query) => {
  const q = query.trim().toLowerCase();
  if (!q) return menuItem;
  if (menuItemMatches(menuItem, q)) return menuItem;
  if (!menuItem.subItems) return null;

  const filteredSubItems = menuItem.subItems
    .map((subItem) => filterMenuItem(subItem, query))
    .filter(Boolean);

  if (filteredSubItems.length === 0) return null;
  return { ...menuItem, subItems: filteredSubItems };
};

const Sidebar = ({ collapsed, fullyCollapsed }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const pathname = location.pathname;
  const width = useResizeWindow();
  const theme = loadFromLocalStorage("theme");

  const role = useSelector((state) => state?.users?.user?.role) || "USER";
  // Menus below are admin-only. This is presentation only — the backend
  // enforces the same rule on every endpoint behind these pages.
  const isPrivileged = role === "ADMIN" || role === "SUPERADMIN";
  const mgwResponsibleExists = useSelector((state) => state?.container?.mgwResponsibleExists);
  const ndResponsibleExists = useSelector((state) => state?.container?.ndResponsibleExists);
  const agentResponsibleExists = useSelector((state) => state?.container?.agentResponsibleExists);
  const [showDelete, setShowDelete] = useState(false);
  const [clickedExpandableItem, setClickedExpandableItem] = useState("");
  const [clickedExpandableSubItem, setClickedExpandableSubItem] = useState("");
  const [menuSearch, setMenuSearch] = useState("");
  const [searchVisible, setSearchVisible] = useState(false);

  const searchActive = menuSearch.trim().length > 0;

  const searchToggleHandler = () => {
    if (searchVisible) setMenuSearch("");
    setSearchVisible(!searchVisible);
  };

  // After navigating to a menu item, close the search and show the whole
  // menu again (same as toggling the magnifier off)
  useEffect(() => {
    setMenuSearch("");
    setSearchVisible(false);
  }, [pathname]);

  const fDashboard = filterMenuItem(dashboardItem, menuSearch);
  const fMa360 = filterMenuItem(ma360Item, menuSearch);
  const fIntegrations = filterMenuItem(integrationsItem, menuSearch);
  const fIoc = filterMenuItem(iocItem, menuSearch);
  const fStatistics = filterMenuItem(statisticsItem, menuSearch);
  const fAgents = filterMenuItem(agentsItem, menuSearch);
  const fNetworkDefender = filterMenuItem(networkDefenderItem, menuSearch);
  const fMailGateway = filterMenuItem(mailGatewayItem, menuSearch);
  const fSettings = filterMenuItem(settingsItem, menuSearch);
  const fPublic = filterMenuItem(publicItem, menuSearch);
  const fInfo = filterMenuItem(infoItem, menuSearch);
  const fContainers = filterMenuItem(containerServicesItem, menuSearch);
  const fLogs = filterMenuItem(logsItem, menuSearch);
  const fIntegrationMarket = filterMenuItem(integrationMarketItem, menuSearch);
  const fProducts = filterMenuItem(productsItem, menuSearch);
  const fPublicApiDocs = filterMenuItem(publicApiDocsItem, menuSearch);

  useEffect(() => {
    dispatch(RequestCheckExistingResponsibles());
  }, [dispatch]);

  // URL'e doğrudan gelindiğinde veya sayfa değiştiğinde menü ağacını otomatik açan useEffect
  useEffect(() => {
    const expandableItems = [
      ma360Item,
      integrationsItem,
      iocItem,
      agentsItem,
      networkDefenderItem,
      mailGatewayItem,
      settingsItem,
      publicItem,
    ];

    for (const item of expandableItems) {
      if (!item.subItems) continue;

      // 1. Kademe (subItem) kontrolü
      const hasMatchingSubItem = item.subItems.some((subItem) => {
        if (subItem.to === pathname) return true;

        // 2. Kademe (grandSubItem - iç içe geçmiş alt sayfa) kontrolü
        if (subItem.subItems) {
          return subItem.subItems.some((grandSubItem) => grandSubItem.to === pathname);
        }
        return false;
      });

      if (hasMatchingSubItem) {
        // Üst ana menüyü aç
        setClickedExpandableItem(item.text);

        // Eğer eşleşen yer bir grandSubItem ise, onun bağlı olduğu subItem'ı da aç
        const matchingSubItem = item.subItems.find((subItem) =>
          subItem.subItems?.some((grandSubItem) => grandSubItem.to === pathname),
        );

        if (matchingSubItem) {
          setClickedExpandableSubItem(matchingSubItem.text);
        }
        break; // Eşleşme bulununca döngüden çık
      }
    }
  }, [pathname]);

  const expandableItemClickHandler = (e, to, text) => {
    if (to === "#") {
      e.preventDefault();
    }
    setClickedExpandableItem((prevState) => {
      if (prevState === text) {
        return "";
      } else {
        return text;
      }
    });
  };

  const expandableSubItemClickHandler = (e, to, text) => {
    if (to === "#") {
      e.preventDefault();
    }
    setClickedExpandableSubItem((prevState) => {
      if (prevState === text) {
        return "";
      } else {
        return text;
      }
    });
  };

  if (fullyCollapsed) return;

  return (
    <div
      className="sidebar"
      style={{
        width: fullyCollapsed ? "0" : collapsed ? "77px" : width <= 1350 ? "180px" : "220px",
      }}>
      <Link to="/dashboard" className="logo">
        <div className="logo__icon">
          {collapsed ? (
            theme === "dataflowx" ? (
              <DataFlowIcon width={30} />
            ) : (
              <LogoIconMain width={30} />
            )
          ) : theme === "dataflowx" ? (
            <section>
              <DataFlowText width={150} /> <DataFlowIcon width={23} />
            </section>
          ) : (
            <div className="sidebar__logo">
              <div className="sidebar__logo__icon" style={{ marginTop: "16px" }}>
                <LogoIconMain width={30} height={38} />
              </div>
              <div className="sidebar__logo__text">
                <strong className="sidebar__logo__text-cyber">Cyber</strong>
                <strong className="sidebar__logo__text-fortress">Fortress</strong>
              </div>
            </div>
          )}
        </div>
      </Link>
      <div className="sidebar__scrollableMenu">
        <div className={`menu ${collapsed ? "menu__border-bottom2" : "menu__border-bottom"}`}>
          {!collapsed && searchVisible && (
            <div className="sidebar__search-row">
              <div className="sidebar__search">
                <SearchIcon width={14} height={14} color="var(--sidebar-item-secondary)" />
                <input
                  autoFocus
                  value={menuSearch}
                  onChange={(e) => setMenuSearch(e.target.value)}
                  placeholder="Search menu..."
                />
                {searchActive ? (
                  <button
                    type="button"
                    className="sidebar__search__clear"
                    title="Clear search"
                    onClick={() => setMenuSearch("")}>
                    ✕
                  </button>
                ) : null}
              </div>
              <button
                type="button"
                className="sidebar__search-toggle sidebar__search-toggle--active"
                title="Close search"
                onClick={searchToggleHandler}>
                <SearchIcon width={14} height={14} color="var(--sidebar-item-secondary)" />
              </button>
            </div>
          )}
          {!collapsed ? (
            searchVisible ? (
              fDashboard && <SidebarItem collapsed={collapsed} item={fDashboard} />
            ) : (
              <div className="sidebar__menu-row">
                {fDashboard ? (
                  <SidebarItem collapsed={collapsed} item={fDashboard} />
                ) : (
                  <div className="sidebar__menu-row__spacer" />
                )}
                <button
                  type="button"
                  className="sidebar__search-toggle"
                  title="Search menu"
                  onClick={searchToggleHandler}>
                  <SearchIcon width={14} height={14} color="var(--sidebar-item-secondary)" />
                </button>
              </div>
            )
          ) : (
            fDashboard && <SidebarItem collapsed={collapsed} item={fDashboard} />
          )}
          {fMa360 && (
            <SidebarItem
              collapsed={collapsed}
              item={fMa360}
              clickedExpandableItem={clickedExpandableItem}
              expandableItemClickHandler={expandableItemClickHandler}
              forceExpand={searchActive}
            />
          )}
          {fIntegrations && (
            <SidebarItem
              collapsed={collapsed}
              item={fIntegrations}
              clickedExpandableItem={clickedExpandableItem}
              expandableItemClickHandler={expandableItemClickHandler}
              clickedExpandableSubItem={clickedExpandableSubItem}
              expandableSubItemClickHandler={expandableSubItemClickHandler}
              forceExpand={searchActive}
            />
          )}
          {fIoc && (
            <SidebarItem
              collapsed={collapsed}
              item={fIoc}
              clickedExpandableItem={clickedExpandableItem}
              expandableItemClickHandler={expandableItemClickHandler}
              forceExpand={searchActive}
            />
          )}
          {fStatistics && <SidebarItem collapsed={collapsed} item={fStatistics} />}
        </div>
        {isPrivileged &&
        ((agentResponsibleExists && fAgents) ||
          (ndResponsibleExists && fNetworkDefender) ||
          (mgwResponsibleExists && fMailGateway)) ? (
          <div className={`menu ${collapsed ? "menu__border-bottom2" : "menu__border-bottom"}`}>
            {agentResponsibleExists && fAgents ? (
              <SidebarItem
                collapsed={collapsed}
                item={fAgents}
                clickedExpandableItem={clickedExpandableItem}
                expandableItemClickHandler={expandableItemClickHandler}
                forceExpand={searchActive}
              />
            ) : null}
            {ndResponsibleExists && fNetworkDefender ? (
              <SidebarItem
                collapsed={collapsed}
                item={fNetworkDefender}
                clickedExpandableItem={clickedExpandableItem}
                expandableItemClickHandler={expandableItemClickHandler}
                forceExpand={searchActive}
              />
            ) : null}
            {mgwResponsibleExists && fMailGateway ? (
              <SidebarItem
                collapsed={collapsed}
                item={fMailGateway}
                clickedExpandableItem={clickedExpandableItem}
                expandableItemClickHandler={expandableItemClickHandler}
                forceExpand={searchActive}
              />
            ) : null}
          </div>
        ) : null}
        {((role === "ADMIN" || role === "SUPERADMIN") &&
          (fSettings || fInfo || fContainers || fLogs)) ||
        (role === "USER" && fPublic) ? (
          <div className={`menu ${collapsed ? "menu__border-bottom2" : "menu__border-bottom"}`}>
            {(role === "ADMIN" || role === "SUPERADMIN") && fSettings && (
              <SidebarItem
                collapsed={collapsed}
                item={fSettings}
                clickedExpandableItem={clickedExpandableItem}
                expandableItemClickHandler={expandableItemClickHandler}
                clickedExpandableSubItem={clickedExpandableSubItem}
                expandableSubItemClickHandler={expandableSubItemClickHandler}
                forceExpand={searchActive}
              />
            )}
            {role === "USER" && fPublic && (
              <SidebarItem
                collapsed={collapsed}
                item={fPublic}
                clickedExpandableItem={clickedExpandableItem}
                expandableItemClickHandler={expandableItemClickHandler}
                forceExpand={searchActive}
              />
            )}
            {(role === "ADMIN" || role === "SUPERADMIN") && fInfo && (
              <SidebarItem collapsed={collapsed} item={fInfo} />
            )}
            {(role === "ADMIN" || role === "SUPERADMIN") && fContainers && (
              <SidebarItem collapsed={collapsed} item={fContainers} />
            )}
            {(role === "ADMIN" || role === "SUPERADMIN") && fLogs && (
              <SidebarItem collapsed={collapsed} item={fLogs} />
            )}
          </div>
        ) : null}
        <div
          style={{
            paddingBottom: "20px",
            marginBottom: "20px",
            width: collapsed ? "80px" : "unset",
          }}>
          {(role === "ADMIN" || role === "SUPERADMIN") && (
            <>
              {fIntegrationMarket && (
                <SidebarItem collapsed={collapsed} item={fIntegrationMarket} />
              )}
              {fProducts && <SidebarItem collapsed={collapsed} item={fProducts} />}
              {fPublicApiDocs && <SidebarItem collapsed={collapsed} item={fPublicApiDocs} />}
            </>
          )}
        </div>
      </div>
      <DemoPopup
        onClickOk={() => setShowDelete(false)}
        show={showDelete}
        setShow={setShowDelete}
        text="This feature is not available in the demo version."
        article="DEMO"
      />
    </div>
  );
};

export default Sidebar;
